import { Manager } from '../Manager';
import { IGameState } from '../../State/Store/store';
import { LevelUtils } from '../Level/LevelUtils';
import { ItemIDs } from '../../Config/Items';
import Core from '../../Core/Core';
import Board from '../Board/Board';
import { Actions } from '../../State/Actions/Actions';

export default class Hint extends Manager {
    private hints: number = 0;
    private board: Board;

    constructor(board: Board) {
        super();

        this.board = board;

        this.addSelector((state: IGameState, pre: IGameState) => {
            this.handleHint(state, pre);
        });
    }

    public cleanUp() {
        super.cleanUp();
    }

    private handleHint(state: IGameState, previous: IGameState) {
        const { StateLevel: level, StateBoosters: boosters } = state;
        const { StateLevel: pre } = previous;
        if (LevelUtils.checkHasHint(level, pre, boosters, this.hints)) {
            this.triggerHint();
        }
        if (!state.StateBoosters.currentBoosters.includes(ItemIDs.HINT) && this.hints > 0) {
            this.board.view.stopHints();
            this.hints = 0;
        }
    }

    private triggerHint() {
        const curBoosters = Core.store.getState().StateBoosters.currentBoosters;
        if (curBoosters.includes(ItemIDs.FIRECRACKER) || curBoosters.includes(ItemIDs.MAGNET)) {
            return;
        }

        this.hints++;
        if (this.hints > 3) {
            this.endHintBooster();
            return;
        }
        const r = Core.store.getState().StateLevel.hints;
        const delay = this.hints === 1 ? 1500 : 0;
        setTimeout(() => {
            const cur = Core.store.getState().StateBoosters.currentBoosters;
            if (cur.includes(ItemIDs.FIRECRACKER) || cur.includes(ItemIDs.MAGNET)) {
                return;
            }
            this.board.showBoardHint(r.slice(r.length - 2), 1000);
        }, delay);
    }

    private endHintBooster() {
        Core.store.dispatch(Actions.removeBoosters([ItemIDs.HINT]));
    }
}
